import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CountersCard from '../../../../ui/CountersCard';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import {
  counterOrganizationsQuery,
  counterRequestsQuery
} from "./reducer";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Организации",
    link: "#"
  },
];

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const ManageOOPResourcesOrgIndex = ({
                                      history,
                                      counterOrganizations,
                                      counterRequests,
                                      counterOrganizationsQuery,
                                      counterRequestsQuery
                                    }) => {

  const classes = useStyles();

  const handleClick = (link) => {
    history.push(link);
  };

  useEffect(() => {
    counterOrganizationsQuery();
  }, [counterOrganizationsQuery]);

  useEffect(() => {
    counterRequestsQuery();
  }, [counterRequestsQuery]);

  return (
    <div>
      <Breadcrumbs items={items}/>
      <div className={classes.root}>
        <Grid container spacing={0} justify="flex-start" alignItems="flex-start">
          {counterOrganizations && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterOrganizations}
              onClick={handleClick}
              goTo={'/work/app/organization'}
            />
          </Grid>}
          {counterRequests && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterRequests}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/org/requests'}
            />
          </Grid>}
        </Grid>
      </div>
    </div>
  )
};

const mapStateToProps = state => ({
  counterOrganizations: state.manageOOPResourcesOrganizationsIndex.counterOrganizations,
  counterRequests: state.manageOOPResourcesOrganizationsIndex.counterRequests
});

const mapDispatchToProps = dispatch => ({
  counterOrganizationsQuery: () => dispatch(counterOrganizationsQuery()),
  counterRequestsQuery: () => dispatch(counterRequestsQuery())
});

export default  connect(mapStateToProps, mapDispatchToProps)(withRouter(ManageOOPResourcesOrgIndex));
